{
  "common": {
    "seeAll": "Zobacz wszystkie",
    "soon": "Wkrótce",
    "soonInfo": "Pracujemy nad tą funkcją. Pojawi się w jednej z najbliższych wersji.",
    "back": "Wstecz",
    "cancel": "Anuluj",
    "daysLeft": "zostało {{count}} dni",
    "inDays": "Za {{count}} dni",
    "today": "Dziś",
    "tomorrow": "Jutro",
    "close": "Zamknij",
    "save": "Zapisz"
  },
  "startSummary": {
    "title": "Podsumowanie",
    "period": {
      "month": "Miesiąc",
      "quarter": "Kwartał",
      "year": "Rok"
    },
    "income": "Przychody",
    "expense": "Wydatki",
    "balance": "Saldo",
    "saved": "Odłożone"
  },
  "policyDetails": {
    "title": "Szczegóły polisy",
    "type": "Rodzaj ubezpieczenia",
    "insurer": "Ubezpieczyciel",
    "number": "Numer polisy",
    "subject": "Przedmiot ubezpieczenia",
    "premium": "Składka",
    "start": "Początek ochrony",
    "end": "Koniec ochrony",
    "techExam": "Przegląd techniczny",
    "source": "Źródło",
    "notSet": "—",
    "delete": "Usuń polisę",
    "deleteConfirm": "Na pewno usunąć tę polisę? Tej operacji nie można cofnąć.",
    "deleteYes": "Tak, usuń",
    "saveEdit": "Zapisz zmiany",
    "documents": "Dokument polisy",
    "noDocument": "Brak dołączonego dokumentu. Dodaj skan lub PDF polisy, żeby mieć go pod ręką.",
    "viewScan": "Zobacz skan",
    "openDocument": "Otwórz dokument",
    "addPhoto": "Zrób zdjęcie",
    "addFromGallery": "Z galerii",
    "addDocument": "Dodaj dokument",
    "addPdf": "Wgraj PDF / plik",
    "removeDocument": "Usuń dokument",
    "offerTitle": "Chcesz ofertę od Polfinance?",
    "offerTitleEnding": "Polisa się kończy — odnów z Polfinance",
    "offerBody": "Sprawdzimy, czy da się taniej, i przygotujemy ofertę wznowienia. Bez zobowiązań.",
    "offerCta": "Uzyskaj ofertę od Polfinance",
    "offerConfirm": "Potwierdź — wyślij zapytanie",
    "offerSending": "Wysyłam…",
    "offerSent": "Zapytanie wysłane — Twój agent się odezwie.",
    "offerConsentTitle": "Wysłać dane do Polfinance?",
    "offerConsentBody": "Prześlemy dane tej polisy (rodzaj, towarzystwo, składka, termin) do Polfinance, żeby agent przygotował dla Ciebie ofertę lub wznowienie — być może taniej. Wysyłasz je świadomie; poza tym Twoje dane zostają na telefonie.",
    "offerConsentBodyDoc": "Prześlemy dane tej polisy (rodzaj, towarzystwo, składka, termin) oraz dokument załączony przy tej polisie do Polfinance, żeby agent przygotował dla Ciebie ofertę lub wznowienie — być może taniej. Wysyłasz je świadomie; poza tym Twoje dane zostają na telefonie.",
    "offerConsentYes": "Rozumiem, wyślij",
    "offerConsentNo": "Rezygnuję"
  },
  "policyType": {
    "CAR_OC": "OC komunikacyjne",
    "CAR_AC": "AC (autocasco)",
    "HOME": "Ubezpieczenie domu / mieszkania",
    "LIFE": "Ubezpieczenie na życie",
    "NNW": "NNW",
    "TRAVEL": "Ubezpieczenie podróżne",
    "HEALTH": "Ubezpieczenie zdrowotne",
    "OTHER": "Inne ubezpieczenie"
  },
  "premiumPeriod": {
    "ANNUAL": "rocznie",
    "SEMI_ANNUAL": "półrocznie",
    "QUARTERLY": "kwartalnie",
    "MONTHLY": "miesięcznie",
    "ONE_OFF": "jednorazowo"
  },
  "policySource": {
    "MANUAL": "Dodane ręcznie",
    "SCAN": "Ze skanu polisy",
    "POLFINANCE": "Polfinance"
  },
  "tabs": {
    "start": "Start",
    "budget": "Budżet",
    "goals": "Cele",
    "policies": "Polisy",
    "more": "Więcej",
    "agent": "Agent",
    "income": "Zarobki"
  },
  "home": {
    "appName": "Opiekun Rodziny",
    "greeting": "Dzień dobry, {{name}}",
    "greetingNoName": "Dzień dobry",
    "greetingSubtitle": "Wasz wspólny budżet i bezpieczeństwo rodziny w jednym miejscu.",
    "budgetTitle": "Budżet — {{month}}",
    "budgetOf": "z {{amount}}",
    "budgetLeftLabel": "zostało do końca miesiąca",
    "planLabel": "Plan",
    "spendLabel": "Wydatki",
    "paceOnTrack": "Idziecie zgodnie z planem ✓",
    "paceOver": "Wydajecie szybciej niż plan",
    "paceDaily": "Na {{days}} dni zostaje ok. {{amount}} dziennie",
    "addExpense": "Dodaj wydatek",
    "verdictOnTrack": "Twój portfel ma się dobrze.",
    "verdictOverPace": "Wydatki rosną szybciej niż plan.",
    "verdictNoBudget": "Zacznij od ustawienia budżetu.",
    "setBudgetCta": "Ustaw budżet miesięczny",
    "spentPct": "{{pct}}% wydane",
    "leftShort": "pozostało",
    "activePolicies": "{{count}} aktywne",
    "recentEntries": "Ostatnie wydatki",
    "urgent": "Pilne terminy",
    "protectionCompact": "Ochrona rodziny: {{percent}}%",
    "protectionCompactSub": "Sprawdź polisy i luki w ochronie",
    "ideasHintTitle": "Masz pomysł albo widzisz błąd?",
    "ideasHintBody": "Zgłoś i głosuj na tablicy — najczęściej wybierane robimy najpierw.",
    "ideasHintCta": "Zobacz tablicę",
    "syncNudgeTitle": "Masz już sporo danych",
    "syncNudgeBody": "Polisy, zarobki, budżet — szkoda by było je stracić przy zmianie telefonu. Załóż konto i włącz kopię w chmurze.",
    "syncNudgeCta": "Zabezpiecz dane",
    "syncNudgeCtaEnable": "Włącz kopię teraz"
  },
  "policies": {
    "title": "Portfel polis",
    "header": "Twoje polisy",
    "subtitle": "Masz {{count}} aktywne ubezpieczenia chroniące Twoją rodzinę.",
    "polfinanceHeader": "Twoje polisy w Polfinance",
    "polfinancePolicy": "Polisa",
    "protectionUntil": "ochrona do",
    "protectionTitle": "Poziom ochrony",
    "protectionBody": "Masz {{count}} aktywne polisy. Dodaj brakujące dane, aby zwiększyć poziom bezpieczeństwa.",
    "protectionRingLabel": "ochrony",
    "completeProfile": "Uzupełnij profil",
    "insurer": "Ubezpieczyciel: {{name}}",
    "premiumAnnual": "Roczna składka",
    "premiumMonthly": "Składka miesięczna",
    "premium": "Składka",
    "perMonthSuffix": "/mc",
    "protectionEnd": "Koniec ochrony",
    "openEnded": "Bezterminowo",
    "statusActive": "Aktywna",
    "statusEndingSoon": "Kończy się",
    "details": "Szczegóły polisy",
    "missingTitle": "Brakuje ważnej polisy?",
    "missingSubtitle": "Dodaj ją i miej wszystko w jednym miejscu.",
    "addScan": "Dodaj zdjęcie polisy",
    "addManual": "Dodaj ręcznie",
    "renewCta": "Odnów z agentem",
    "endedHeader": "Zakończone polisy ({{count}})",
    "viewDocument": "Zobacz dokument polisy",
    "noDocumentYet": "Dokument doda Twój agent w Polfinance",
    "statusEnded": "Zakończona",
    "coverageFrom": "od {{date}}"
  },
  "budget": {
    "title": "Budżet",
    "addTitle": "Dodaj wydatek",
    "left": "Zostało:",
    "chooseCategory": "Wybierz kategorię",
    "saveEntry": "Zapisz wydatek",
    "savedToast": "Zapisano ✓",
    "categories": {
      "FOOD": "Jedzenie",
      "FUEL": "Paliwo",
      "BILLS": "Rachunki",
      "INSTALLMENTS": "Raty",
      "KIDS": "Dzieci",
      "HOME": "Dom",
      "HEALTH": "Zdrowie",
      "FUN": "Rozrywka",
      "OTHER": "Inne"
    },
    "favoritesHint": "Przytrzymaj skrót, aby go zmienić",
    "noteLabel": "Nazwa (opcjonalnie)",
    "notePlaceholder": "np. LEGO, kino, Biedronka"
  },
  "goals": {
    "title": "Wasze cele",
    "subtitle": "Odkładajcie razem — postęp widać na jednym kółku.",
    "totalSavings": "Suma oszczędności",
    "streak": "Świetnie Wam idzie!",
    "tipTitle": "Wskazówka doradcy",
    "tipProgress": "W tym miesiącu dopisaliście już {{amount}} do celów. Tak trzymać!",
    "tipStart": "Dopisz pierwszą wpłatę — nawet 50 zł robi różnicę.",
    "saved": "{{saved}} z {{target}}",
    "targetDate": "do {{date}}",
    "newGoal": "Nowy cel"
  },
  "goalDetails": {
    "title": "Szczegóły celu",
    "ofTarget": "z {{target}}",
    "percentOfGoal": "{{percent}}% celu",
    "addContribution": "Dopisz wpłatę",
    "saveContribution": "Dopisz",
    "recentContributions": "Ostatnie wpłaty",
    "upsellChip": "TYLKO 0,04%",
    "upsellBody": "Chronisz {{target}} oszczędności rodziny. Ubezpieczenie na życie od 49 zł/mies. — to ułamek tego, co budujecie.",
    "askGuardian": "Zapytaj opiekuna",
    "milestoneBody": "Uzbieraliście już {{saved}} — brawo. Chcesz zabezpieczyć bliskich na wypadek, gdyby Cię zabrakło? Ubezpieczenie na życie od ok. 49 zł/mies.",
    "firstContribTitle": "Brawo, pierwsza wpłata!",
    "firstContribBody": "Najtrudniejszy krok za Wami. Regularność zrobi resztę.",
    "starterHintTitle": "Nawet 50 zł to dobry start",
    "starterHintBody": "Pierwsza wpłata buduje nawyk — kwota jest mniej ważna niż regularność.",
    "askDraft": "Odkładam na cel „{{name}}\" i chcę zabezpieczyć bliskich — proszę o ofertę ubezpieczenia na życie."
  },
  "newGoal": {
    "title": "Nowy cel",
    "motto": "Krok po kroku do marzeń",
    "nameLabel": "Nazwa celu",
    "namePlaceholder": "Np. Nasz wymarzony dom",
    "templateDownPayment": "Wkład własny",
    "templateVacation": "Wakacje",
    "templateEmergencyFund": "Poduszka bezpieczeństwa",
    "templateCustom": "Własny cel",
    "targetLabel": "Kwota docelowa (zł)",
    "startingLabel": "Ile już macie odłożone? (zł)",
    "startingHint": "Zaczniemy od tego, co już macie — nie od zera.",
    "dateLabel": "Data celu (opcjonalnie)",
    "forecastTitle": "Ile odkładać miesięcznie",
    "forecastNeeded": "Aby zdążyć do {{date}} ({{months}} mies.), odkładajcie ok. {{amount}} miesięcznie.",
    "forecastNoDate": "Podaj datę celu, a policzymy ile trzeba odkładać miesięcznie.",
    "forecastPast": "Wybierz datę w przyszłości, żeby policzyć miesięczną kwotę.",
    "create": "Utwórz cel",
    "dataSafe": "Twoje dane są bezpieczne z Opiekunem Rodziny"
  },
  "household": {
    "title": "Wasze gospodarstwo",
    "heroSubtitle": "Wspólny budżet i cele — widzicie to samo na dwóch telefonach.",
    "syncSoon": "Wspólne dane zsynchronizują się, gdy druga osoba dołączy kodem",
    "members": "Domownicy",
    "invite": "Zaproś drugą osobę",
    "activity": "Ostatnia aktywność",
    "activityExpense": "dodał(a) wydatek: {{category}} {{amount}}",
    "activityContribution": "dopisał(a) wpłatę: {{goal}} {{amount}}",
    "settings": "Ustawienia gospodarstwa",
    "syncOn": "Wspólne dane synchronizują się między telefonami",
    "inviteCode": "Kod zaproszenia do gospodarstwa",
    "haveCode": "Mam kod zaproszenia do gospodarstwa",
    "codeLabel": "Kod zaproszenia",
    "joinCta": "Dołącz do gospodarstwa",
    "joinError": "Nie udało się dołączyć. Sprawdź kod i spróbuj ponownie.",
    "referralCode": "Twój kod polecenia (talon 50 zł na paliwo)",
    "referralCodeHint": "Podaj go nowej osobie — gdy założy konto z tym kodem i kupi polisę w Polfinance, oboje dostaniecie po 50 zł na paliwo (talon).",
    "memberPending": "Zaproszenie wysłane · czeka na dołączenie",
    "connectHeader": "Połącz dwa telefony",
    "connectExplain": "Jeden telefon tworzy kod, drugi go wpisuje. Wspólny budżet, cele i wpłaty synchronizują się przez serwer Polfinance (serwer je przechowuje, nie czyta). Polisy i Skarbiec zostają prywatne na każdym telefonie.",
    "createCode": "Utwórz kod zaproszenia",
    "guestConnect": "Wspólny budżet działa przez serwer, więc musisz być zalogowany na obu telefonach: jeden tworzy kod, drugi go wpisuje. Bez logowania dane zostają tylko na tym telefonie.",
    "loginCta": "Zaloguj się, aby połączyć",
    "joinMergeNote": "Po dołączeniu Wasze dane się POŁĄCZĄ: Twoje wpisy (budżet, cele, zarobki, opłaty) zostają, dołączą wpisy drugiej osoby. Nic się nie kasuje ani nie nadpisuje pustymi danymi.",
    "joinedToast": "Dołączyłeś do gospodarstwa {{name}}",
    "joinedToastSub": "Wspólny budżet i cele zsynchronizują się za chwilę.",
    "joinFailedToast": "Nie udało się dołączyć do gospodarstwa",
    "joinFailedToastSub": "Sprawdź kod w menu Moje gospodarstwo — możesz wpisać go tam ponownie."
  },
  "summary": {
    "title": "Podsumowanie budżetu",
    "subtitle": "Podsumowanie wydatków",
    "spent": "Wydane",
    "insightBiggest": "{{category}}: największa kategoria — {{pct}}% wydatków tego miesiąca.",
    "categories": "Kategorie",
    "pctOfBudget": "{{pct}}% wszystkich wydatków",
    "empty": "Brak wydatków w tym miesiącu.",
    "addExpense": "Dodaj nowy wydatek",
    "budgetTitle": "Budżet miesięczny",
    "budgetEmptyHint": "Ustaw budżet, aby apka pilnowała tempa wydatków.",
    "budgetSet": "Ustaw budżet",
    "budgetEdit": "Zmień budżet",
    "budgetPlaceholder": "np. 5 000",
    "budgetSave": "Zapisz budżet",
    "budgetWhatHint": "Wpisz łączną kwotę na WSZYSTKIE wydatki miesiąca — jedzenie, rachunki, paliwo, raty. Wszystko liczymy tutaj.",
    "budgetHelpCta": "Nie wiesz ile? Policz z nami",
    "budgetOverIncome": "Budżet jest wyższy niż Twoje zarobki w tym miesiącu ({{income}}). Uzupełnij zarobki.",
    "operations": "Operacje",
    "editAmountLabel": "Kwota (zł)",
    "deleteEntry": "Usuń wydatek",
    "deleteConfirm": "Na pewno usunąć? Dotknij ponownie",
    "noteEmpty": "Bez nazwy"
  },
  "protection": {
    "title": "Analiza Twojej ochrony",
    "question": "Czy jesteś dobrze chroniony?",
    "analyzed": "Opiekun przeanalizował Twój portfel na tym telefonie.",
    "yourSituation": "Twoja sytuacja",
    "gaps": "Brakuje Ci ochrony: {{list}}. Może to wpłynąć na bezpieczeństwo finansowe rodziny.",
    "askAgent": "Zapytaj agenta o wycenę",
    "askAgentConfirm": "Potwierdź — wyślij zapytanie",
    "askAgentConfirmHint": "Twój opiekun w Polfinance dostanie zapytanie z podsumowaniem analizy i skontaktuje się z Tobą.",
    "askAgentSending": "Wysyłam…",
    "askAgentSent": "Zgłoszenie wysłane — agent skontaktuje się z Tobą.",
    "askAgentPending": "Twoje zapytanie o wycenę czeka u agenta — skontaktuje się z Tobą.",
    "askAgentError": "Nie udało się wysłać zapytania. Spróbuj ponownie."
  },
  "newPolicy": {
    "title": "Dodaj polisę",
    "subtitle": "Kilka pól wystarczy — resztę uzupełnisz później albo doda ją Twój opiekun.",
    "insurer": "Towarzystwo",
    "premium": "Składka roczna (zł)",
    "openEnded": "Polisa bezterminowa (np. życie)",
    "endDate": "Koniec ochrony",
    "dateInvalid": "Podaj datę w formacie dd.mm.rrrr",
    "reminderHint": "Przypomnimy 30, 14, 7 i 1 dzień przed końcem.",
    "scanTitle": "Dodaj zdjęcie polisy",
    "scanHint": "Zrób zdjęcie aparatem lub wybierz plik — odczytamy pola za Ciebie i wypełnimy formularz. Zdjęcia nie zapisujemy na serwerze.",
    "scanCamera": "Zrób zdjęcie",
    "scanGallery": "Z galerii",
    "scanReading": "Czytamy polisę…",
    "scanReadingHint": "Zwykle 10–30 s. Duży PDF może potrwać dłużej.",
    "scanTimeout": "Odczyt trwa zbyt długo — sprawdź połączenie i spróbuj ponownie (dane możesz też wpisać ręcznie).",
    "scanError": "Nie udało się odczytać pliku. Spróbuj ponownie.",
    "scanLoginRequired": "Odczyt AI wymaga logowania. Zaloguj się w zakładce Więcej → Konto — albo wpisz dane ręcznie poniżej.",
    "scanDone": "Odczytano — sprawdź pola poniżej przed zapisem.",
    "scanLimitGuest": "Bez logowania: 4 darmowe odczyty AI dziennie (łącznie 8). Zaloguj się, aby mieć 10 dziennie →",
    "number": "Numer polisy (opcjonalnie)",
    "numberPlaceholder": "np. PZ123456789",
    "customName": "Nazwa własna (opcjonalnie)",
    "customNamePlaceholder": "np. Auto (Corolla)",
    "save": "Zapisz polisę",
    "scanPdf": "Wgraj PDF / plik",
    "startDate": "Początek ochrony",
    "scanLimitGuestWall": "Wykorzystane darmowe odczyty AI. Zaloguj się — zalogowani mają do 10 skanów dziennie.",
    "techExamDate": "Data następnego przeglądu technicznego (opcjonalnie)",
    "techExamHint": "Przypomnimy Ci 30, 14, 7 i 1 dzień przed przeglądem."
  },
  "reminders": {
    "title": "Przypomnienia",
    "subtitle": "Pilnujemy terminów za Ciebie — przypomnimy z wyprzedzeniem.",
    "webInfo": "Powiadomienia działają w aplikacji na telefonie.",
    "pushOn": "Powiadomienia włączone — przypomnimy 30, 14, 7 i 1 dzień przed terminem.",
    "pushOff": "Powiadomienia wyłączone — włącz je w ustawieniach telefonu, żeby nic Cię nie ominęło.",
    "agentChatTitle": "Wiadomości od agenta",
    "agentChatSubtitle": "Napisz do swojego opiekuna albo sprawdź odpowiedź."
  },
  "newReminder": {
    "title": "Nowe przypomnienie",
    "subtitle": "Terminy polis i opłat dodajemy automatycznie — tu dopiszesz własne (np. telefon, wizyta, dokument do odnowienia).",
    "nameLabel": "Czego dotyczy?",
    "namePlaceholder": "np. Zadzwoń do agenta, przegląd auta",
    "dateLabel": "Data",
    "noteLabel": "Notatka (opcjonalnie)",
    "notePlaceholder": "np. numer telefonu, szczegóły",
    "hint": "Przypomnimy 7 i 1 dzień przed oraz w dniu terminu.",
    "save": "Zapisz przypomnienie"
  },
  "agent": {
    "title": "Twój agent",
    "specialistsHeader": "Dostępni specjaliści",
    "insuranceTitle": "Agent ubezpieczeniowy",
    "insuranceSubtitle": "Ochrona Twojego majątku",
    "insuranceBody": "Agent ubezpieczeniowy pomaga dobrać i wznowić polisy: auto, dom, życie, firma. Jeśli połączysz konto, przypiszemy Ci Twojego osobistego opiekuna — będzie znał Twoje polisy i przypomni o terminach.",
    "notLinkedInfo": "Brak przypisanego agenta. Połącz konto z Polfinance, a zobaczysz tu swojego opiekuna.",
    "connectCta": "Podłącz konto, aby przypisać agenta",
    "caretakerHeader": "Twój opiekun",
    "caretakerRole": "Agent Polfinance",
    "call": "Zadzwoń",
    "text": "Napisz",
    "noPhone": "Twój opiekun jest przypisany — skontaktuj się przez biuro Polfinance.",
    "noAgentYet": "Konto połączone. Opiekun zostanie przypisany przez biuro — pojawi się tutaj.",
    "creditTitle": "Specjalista kredytowy",
    "creditSubtitle": "Optymalizacja Twoich zobowiązań",
    "creditBody": "Kredyt hipoteczny, refinansowanie, konsolidacja — współpracujemy ze specjalistami kredytowymi. Zostaw temat, a biuro połączy Cię z właściwą osobą.",
    "creditCta": "Zapytaj o kredyt",
    "creditCtaConnect": "Podłącz konto, aby zapytać o kredyt",
    "creditConfirm": "Potwierdź — wyślij zgłoszenie",
    "creditSending": "Wysyłanie…",
    "creditSent": "Zgłoszenie wysłane — specjalista kredytowy się odezwie.",
    "creditError": "Nie udało się wysłać. Spróbuj ponownie.",
    "startChat": "Rozpocznij czat",
    "creditKindLabel": "Jaki kredyt?",
    "creditKindMortgage": "Hipoteczny",
    "creditKindCash": "Gotówkowy",
    "creditPurposeLabel": "Cel",
    "creditPurposeBuyFlat": "Zakup mieszkania",
    "creditPurposeBuyHouse": "Zakup domu",
    "creditPurposeBuild": "Budowa",
    "creditPurposeRefinance": "Refinansowanie",
    "creditPurposeCash": "Kredyt gotówkowy",
    "creditPurposeConsolidation": "Konsolidacja",
    "creditPurposeOther": "Inne",
    "creditAmountLabel": "Kwota kredytu (zł)",
    "creditNoteLabel": "Powiedz coś o swoim kredycie (opcjonalnie)",
    "creditNotePlaceholder": "np. rata obecnego kredytu, dochód, cel — dzięki temu agent od razu ma punkt zaczepienia",
    "creditSubmit": "Wyślij zgłoszenie"
  },
  "more": {
    "title": "Więcej",
    "reminders": "Przypomnienia",
    "agent": "Mój agent",
    "budgetSummary": "Podsumowanie budżetu",
    "household": "Wspólne gospodarstwo",
    "protection": "Analiza ochrony",
    "settings": "Ustawienia",
    "accountTitle": "Twoje konto",
    "loggedIn": "Zalogowano",
    "logout": "Wyloguj",
    "logoutConfirmTitle": "Wylogować z konta?",
    "logoutConfirmBody": "Wylogowujesz się z konta w aplikacji — nie z samej aplikacji. Synchronizacja z chmurą przestanie działać, a Twoje dane pozostaną na tym urządzeniu.",
    "logoutConfirmYes": "Wyloguj się",
    "logoutConfirmNo": "Zostań zalogowany",
    "loginCta": "Zaloguj się",
    "loginCtaSubtitle": "Polisy z Polfinance i synchronizacja — po zalogowaniu",
    "analyticsTitle": "Pomóż ulepszać aplikację",
    "analyticsHint": "Anonimowe statystyki, które ekrany są przydatne. Bez Twojej zgody nic nie wysyłamy. Nigdy nie zbieramy kwot ani numerów polis. Możesz wyłączyć w każdej chwili.",
    "cloudSyncTitle": "Synchronizuj z chmurą",
    "cloudSyncHint": "Kopia na serwerze Polfinance — zapisujemy ją, ale nie analizujemy. Nie zniknie przy zmianie telefonu.",
    "syncStartedToast": "Włączono — synchronizuję…",
    "syncOkToast": "Zsynchronizowano",
    "syncFailToast": "Nie udało się zsynchronizować",
    "syncStatusOk": "Ostatnia synchronizacja: {{when}}",
    "syncStatusFail": "Ostatnia próba nieudana: {{when}}",
    "agentInsurance": "Twój agent ubezpieczeniowy",
    "creditSpecialist": "Specjalista kredytowy",
    "chat": "Czat z nami",
    "refer": "Poleć aplikację znajomym",
    "about": "O Polfinance",
    "whyApp": "Po co ta aplikacja?",
    "privacy": "Prywatność i dane",
    "version": "Wersja aplikacji {{version}}",
    "copyright": "POLFINANCE © {{year}}",
    "ideas": "Tablica pomysłów i błędów",
    "vault": "Skarbiec rodziny",
    "school": "Szkoła finansów",
    "legal": "Regulamin i zasady",
    "tutorial": "Przewodnik po aplikacji",
    "fontSize": "Rozmiar czcionki",
    "fontSmall": "Mała",
    "fontDefault": "Domyślna",
    "fontLarge": "Duża",
    "fontXlarge": "Największa"
  },
  "chat": {
    "title": "Czat z nami",
    "placeholder": "Napisz wiadomość…",
    "send": "Wyślij",
    "empty": "Napisz, w czym możemy pomóc — odpowiemy najszybciej jak się da.",
    "loadError": "Nie udało się wczytać rozmowy. Spróbuj ponownie.",
    "sendError": "Nie udało się wysłać wiadomości. Spróbuj ponownie.",
    "closedInfo": "Rozmowa została zakończona. Napisz nową wiadomość, aby zacząć od nowa.",
    "linkRequiredTitle": "Czat dla klientów Polfinance",
    "linkRequiredBody": "Żebyśmy wiedzieli, z kim rozmawiamy i mogli pomóc z Twoimi polisami, podłącz konto do Polfinance. Zajmie to chwilę.",
    "linkCta": "Podłącz konto"
  },
  "agentMode": {
    "title": "Moi klienci",
    "greeting": "Dzień dobry, {{name}}",
    "searchPlaceholder": "Szukaj klienta…",
    "filterAll": "Wszyscy",
    "filterWithApp": "Z aplikacją",
    "hasAppBadge": "ma aplikację",
    "policiesCount_one": "{{count}} polisa",
    "policiesCount_few": "{{count}} polisy",
    "policiesCount_many": "{{count}} polis",
    "lastPolicyEnd": "ochrona do {{date}}",
    "empty": "Nie znaleźliśmy klientów w Twoim portfelu.",
    "emptySearch": "Brak klientów dla podanej frazy.",
    "loadError": "Nie udało się pobrać listy klientów. Spróbuj ponownie.",
    "notAgent": "Tryb agenta jest niedostępny dla tego konta.",
    "client": {
      "title": "Karta klienta",
      "call": "Zadzwoń",
      "sms": "Napisz SMS",
      "email": "E-mail",
      "policiesHeader": "Polisy klienta",
      "noPolicies": "Brak polis w systemie.",
      "endsIn": "koniec ochrony {{date}}",
      "loadError": "Nie udało się pobrać karty klienta."
    },
    "chat": {
      "entry": "Wiadomości od klientów",
      "entryAdmin": "Wszystkie czaty (admin)",
      "title": "Wiadomości",
      "titleAdmin": "Wszystkie czaty",
      "empty": "Brak rozmów z Twoimi klientami.",
      "emptyAdmin": "Brak rozmów.",
      "unread": "nowa wiadomość",
      "loadError": "Nie udało się pobrać rozmów. Spróbuj ponownie.",
      "paneTitle": "Czat z klientem",
      "assigned": "prowadzi: {{name}}",
      "channelApp": "Aplikacja"
    }
  },
  "refer": {
    "title": "Poleć aplikację",
    "heroTitle": "Podoba Ci się?\nPoleć znajomym.",
    "bonusBody": "Poleć osobę, która jest nowym klientem — gdy założy konto z Twoim kodem i kupi polisę w Polfinance, oboje dostaniecie po 50 zł na paliwo (talon).",
    "bonusCondition": "* Warunek: osoba polecona jest nowa (nigdy nie miała polis w Polfinance) i kupi polisę w Polfinance.",
    "sendSms": "Wyślij link SMS-em",
    "share": "Udostępnij",
    "yourCode": "Twój kod polecenia",
    "copied": "Skopiowano kod",
    "howItWorks": "Znajomy wpisuje Twój kod przy logowaniu (pole „Mam kod polecenia”). Talony przypisujemy do 48 h od spełnienia warunków — wypłatę potwierdza biuro Polfinance.",
    "shareText": "Polecam Ci darmową aplikację Opiekun Rodziny od Polfinance — polisy i budżet domowy w jednym miejscu. Pobierz: {{url}} • Przy logowaniu wpisz mój kod: {{code}}. Jeśli jesteś nowym klientem i kupisz polisę w Polfinance, oboje dostaniemy po 50 zł na paliwo (talon).",
    "guestPitch": "Kod polecenia jest przypisany do Twojego konta. Zaloguj się, aby dostać swój kod i polecać aplikację znajomym.",
    "qrHint": "Zeskanuj kod telefonem znajomego — otworzy się link do aplikacji z Twoim kodem polecenia.",
    "guestSharePitch": "Podoba Ci się? Podeślij aplikację znajomym — nie potrzebujesz do tego konta.",
    "guestShare": "Wyślij link do aplikacji",
    "guestShareText": "Polecam Ci darmową aplikację Opiekun Rodziny od Polfinance — polisy i budżet domowy w jednym miejscu. Pobierz: {{url}}. Jak się zalogujesz i jako nowy klient kupisz polisę w Polfinance, oboje dostaniemy po 50 zł na paliwo (talon).",
    "guestVoucherNote": "Aby dostać talon 50 zł na paliwo — zaloguj się i miej swój kod. Gdy nowy klient kupi polisę w Polfinance, talon dostaniecie oboje.",
    "guestLoginCta": "Zaloguj się, aby mieć swój kod",
    "linkCopied": "Skopiowano link",
    "cases": {
      "title": "Moje polecenia",
      "empty": "Jeszcze nikt nie użył Twojego kodu. Podeślij go znajomym!",
      "loadError": "Nie udało się wczytać poleceń.",
      "unknownPerson": "Polecona osoba",
      "statuses": {
        "SUBMITTED": "Zgłoszone",
        "PURCHASED": "Kupił polisę",
        "VOUCHER_GRANTED": "Talon do odbioru",
        "VOUCHER_COLLECTED": "Talon odebrany",
        "REJECTED": "Nie spełniło warunków"
      },
      "collectCta": "Odbierz talon 50 zł",
      "collectTitle": "Odbiór talonu",
      "collectInfo": "Podaj swoje dane — to cyfrowe potwierdzenie odbioru talonu (zamiast podpisu w biurze). Po zatwierdzeniu zobaczysz kod e-karty.",
      "firstName": "Imię",
      "lastName": "Nazwisko",
      "address": "Adres (opcjonalnie)",
      "confirmCollect": "Potwierdzam odbiór",
      "collectError": "Nie udało się odebrać talonu. Spróbuj ponownie.",
      "voucherCode": "Kod Twojej e-karty ({{amount}} zł)",
      "voucherHint": "Pokaż kod na stacji albo użyj zgodnie z instrukcją karty podarunkowej.",
      "codeCopied": "Skopiowano kod e-karty"
    }
  },
  "privacy": {
    "title": "Prywatność i dane",
    "heroTitle": "Twoje dane są bezpieczne",
    "heroSubtitle": "Prywatność jest fundamentem zaufania w zarządzaniu budżetem domowym.",
    "localTitle": "Domyślnie nic nie wysyłamy",
    "localBody": "Twój budżet, cele i notatki zostają na Twoim telefonie. Nie mamy do nich dostępu.",
    "noTrackingTitle": "Niczego nie monitorujemy",
    "noTrackingBody": "Żadnej lokalizacji, stylu jazdy ani zaglądania w telefon. Agencja dostaje sygnał dopiero, gdy sam klikniesz „skontaktuj się\" — i tylko to, co wpiszesz.",
    "anonTitle": "Jesteś anonimowy",
    "anonBody": "Nie musisz podawać żadnych danych, żeby korzystać z aplikacji. Możesz zarządzać finansami bez konta.",
    "cloudTitle": "Chcesz mieć kopię? Włącz chmurę",
    "cloudBody": "Po zalogowaniu możesz włączyć kopię na serwerze Polfinance — przyda się przy zmianie telefonu. Zapisujemy ją, ale jej nie analizujemy i nie zaglądamy do środka.",
    "securityNote": "POŁĄCZENIE SZYFROWANE (TLS) · DANE NA SERWERACH AWS W UE",
    "loginForCloud": "Zaloguj się, aby włączyć chmurę",
    "policyBackupTitle": "Kopia skanów polis w chmurze",
    "policyBackupHint": "Zdjęcia i PDF-y polis, które skanujesz, zapiszą się dodatkowo na serwerach Polfinance (UE, szyfrowane). Możesz je usunąć w każdej chwili. Domyślnie wyłączone.",
    "policyHealthConsent": "Zgadzam się na kopię polis na życie i zdrowotnych (mogą zawierać dane o zdrowiu)"
  },
  "whyApp": {
    "title": "Po co ta aplikacja?",
    "hookLine1": "Gubią Ci się polisy?",
    "hookLine2": "Nie wiesz, gdzie uciekają pieniądze?",
    "hookLine3": "Ta aplikacja jest dla Ciebie.",
    "policiesTitle": "Wszystkie polisy w jednym miejscu",
    "policiesBody": "Koniec z szukaniem papierów w szufladach. Wszystko masz pod ręką.",
    "budgetTitle": "Prosty budżet domowy",
    "budgetBody": "Zapisuj wydatki w 5 sekund i zobacz, czy idziecie zgodnie z planem.",
    "agentTitle": "Agent pod ręką",
    "agentBody": "Masz pytanie? Twój agent Polfinance jest pod ręką, gotowy do pomocy.",
    "whoTitle": "Kim jesteśmy",
    "whoBody": "Polfinance to multiagencja ubezpieczeniowa, która dba o bezpieczeństwo rodzin. Wierzymy, że technologia powinna służyć człowiekowi — dlatego stworzyliśmy to narzędzie, aby zarządzanie domowymi finansami było tak proste, jak to tylko możliwe.",
    "lookAround": "Rozejrzyj się"
  },
  "about": {
    "title": "O Polfinance",
    "tagline": "Multiagencja ubezpieczeniowa — ochrona majątku, życia i finansów rodziny.",
    "body1": "Pomagamy rodzinom i firmom dobrać ubezpieczenia: majątkowe, komunikacyjne, na życie i grupowe. Porównujemy oferty wielu towarzystw i prowadzimy klienta od wyboru polisy po zgłoszenie szkody.",
    "body2": "Ta aplikacja jest bezpłatna. Powstała, aby nasi klienci (i nie tylko) mieli swoje polisy i domowy budżet w jednym miejscu.",
    "contact": "Kontakt"
  },
  "auth": {
    "loginTitle": "Zaloguj się",
    "phoneTitle": "Podaj swój numer telefonu",
    "phoneSubtitle": "Wyślemy Ci kod SMS — bez haseł do zapamiętywania.",
    "phoneLabel": "Numer telefonu",
    "sendCode": "Wyślij kod",
    "stayGuest": "Wolę wejść bez konta (tryb gościa)",
    "referralToggle": "Mam kod polecenia",
    "referralLabel": "Kod polecenia (opcjonalnie)",
    "referralHint": "Wpisz kod od znajomego — jeśli jesteś nowym klientem i kupisz polisę w Polfinance, oboje dostaniecie po 50 zł na paliwo (talon).",
    "privacyFooter": "Twoje dane z aplikacji zostają na tym telefonie.",
    "codeTitle": "Wpisz kod z SMS-a",
    "codeSubtitle": "Wysłaliśmy 6-cyfrowy kod na numer",
    "resend": "Wyślij nowy kod",
    "resendIn": "Wyślij nowy kod ({{seconds}} s)",
    "login": "Zaloguj się",
    "startOver": "Sesja logowania wygasła. Zacznij od podania numeru.",
    "genericError": "Coś poszło nie tak. Spróbuj ponownie.",
    "connectTitle": "Masz polisy w Polfinance?",
    "connectSubtitle": "Połącz konto, a Twoje polisy pojawią się automatycznie.",
    "matchFound": "Znaleźliśmy klienta: {{name}}",
    "matchPolicies": "Liczba polis: {{count}}",
    "benefitPolicies": "Twoje polisy w jednym miejscu",
    "benefitAgent": "Twój opiekun pod ręką",
    "benefitRenewals": "Szybkie wznowienia — nie przegapisz OC",
    "connect": "Połącz konto",
    "skipForNow": "Pomiń na razie",
    "needHelp": "Potrzebuję pomocy z połączeniem",
    "multipleInfo": "Kilka osób ma polisy pod Twoim numerem. Podaj PESEL, żeby wskazać właściwą.",
    "peselLabel": "PESEL",
    "helpTitle": "Pomoc z połączeniem",
    "helpIntro": "Podaj kilka informacji, a nasze biuro ręcznie przypisze Twoje polisy do konta.",
    "helpFirstName": "Imię",
    "helpLastName": "Nazwisko",
    "helpOtherPhone": "Inny numer telefonu",
    "helpHint": "Wskazówka dla biura",
    "helpHintPlaceholder": "np. polisy na firmę, nazwisko agenta",
    "optional": "opcjonalnie",
    "helpSubmit": "Wyślij zgłoszenie",
    "helpSentTitle": "Zgłoszenie przyjęte",
    "helpSentBody": "Odezwiemy się, gdy przypiszemy Twoje polisy do konta.",
    "helpSentDone": "Wróć do aplikacji",
    "helpPendingInfo": "Twoje zgłoszenie o przypisanie polis czeka na obsługę przez biuro.",
    "hubTitle": "Zaloguj się do Opiekuna Rodziny",
    "hubSubtitle": "Logowanie zabezpiecza Twoje dane w chmurze i pozwala je odzyskać na nowym telefonie.",
    "googleButton": "Zaloguj przez Google",
    "googleBusy": "Logowanie…",
    "googleSoon": "Logowanie Google będzie dostępne wkrótce. Użyj e-maila lub SMS-a.",
    "orDivider": "albo",
    "emailLabel": "Adres e-mail",
    "emailHint": "Bez hasła — wyślemy Ci link do kliknięcia.",
    "sendLink": "Wyślij link do logowania",
    "phoneFallback": "Zaloguj numerem telefonu (SMS)",
    "hubFooter": "Twoje dane finansowe zostają na telefonie.",
    "emailSentTitle": "Sprawdź skrzynkę",
    "emailSentBody": "Kliknij link w mailu od opiekun@polfinance.pl wysłanym na {{email}}, a wrócisz tu zalogowany.",
    "emailWaiting": "Czekam na potwierdzenie…",
    "emailExpiredTitle": "Link wygasł",
    "emailExpiredBody": "Link był ważny 10 minut. Wyślij nowy mail i spróbuj ponownie.",
    "emailCodeToggle": "Nie możesz kliknąć linku? Wpisz kod z maila",
    "emailCodeLabel": "Kod z maila (6 cyfr)",
    "emailCodeVerify": "Potwierdź kod",
    "emailResend": "Wyślij ponownie",
    "emailResendIn": "Wyślij ponownie ({{s}} s)",
    "emailChangeAddress": "Zmień adres e-mail",
    "restoreTitle": "Odzyskaj swoje dane",
    "restoreHeadline": "Potwierdź numer telefonu",
    "restoreBody": "Dla bezpieczeństwa Twoich danych finansowych wyślemy kod SMS na numer {{phone}} przypisany do konta.",
    "restoreNoPhoneBody": "Dodaj numer telefonu — to podwójne zabezpieczenie Twoich danych i klucz do ich odzyskania na nowym telefonie.",
    "addPhoneTitle": "Dodaj numer telefonu",
    "addPhoneHeadline": "Potwierdź numer telefonu",
    "addPhoneBody": "Numer przyda się do kontaktu z opiekunem i zabezpieczy Twoje dane w chmurze.",
    "addPhoneCodeLabel": "Kod z SMS-a (6 cyfr)",
    "addPhoneSend": "Wyślij kod SMS",
    "addPhoneVerify": "Potwierdź numer",
    "addPhoneResend": "Wyślij kod ponownie",
    "addPhoneLater": "Później"
  },
  "onboarding": {
    "welcomeTitle": "Witaj w Opiekunie Rodziny",
    "welcomeBody": "Pomożemy Ci zadbać o budżet i ochronę Twojej rodziny — prosto i bez logowania.",
    "welcomeFeature": {
      "budget": "Budżet domowy pod kontrolą",
      "policies": "Wszystkie polisy w jednym miejscu",
      "goals": "Cele oszczędnościowe",
      "reminders": "Przypomnienia o terminach"
    },
    "nameLabel": "Jak masz na imię? (opcjonalnie)",
    "namePlaceholder": "np. Wojciech",
    "privacyTitle": "Twoje dane zostają u Ciebie",
    "privacySubtitle": "Zanim zaczniemy — kilka słów o prywatności.",
    "privacyLocalTitle": "Wszystko na Twoim telefonie",
    "privacyLocalBody": "Budżet, cele i zarobki zapisują się tylko na tym urządzeniu. Nie mamy do nich dostępu.",
    "privacyNoTrackTitle": "Niczego nie monitorujemy",
    "privacyNoTrackBody": "Żadnej lokalizacji, stylu jazdy ani zaglądania w telefon.",
    "privacySyncTitle": "Chcesz kopię? Włączysz sam",
    "privacySyncBody": "Po zalogowaniu jednym kliknięciem włączysz synchronizację — przyda się przy zmianie telefonu.",
    "situationTitle": "Twoja sytuacja",
    "situationSubtitle": "Zaznacz tylko to, co posiadasz — dopasujemy ochronę. Nic z listy? Po prostu przejdź dalej.",
    "situationHome": "Własne mieszkanie / dom",
    "situationCar": "Samochód",
    "situationKids": "Dzieci",
    "situationMortgage": "Kredyt / rata",
    "situationBusiness": "Działalność / firma",
    "budgetTitle": "Budżet miesięczny",
    "budgetSubtitle": "Podaj łączną kwotę, jaką planujesz wydawać miesięcznie — na wszystko razem. Zmienisz ją później.",
    "budgetLabel": "Kwota (zł)",
    "budgetHint": "To pole jest opcjonalne.",
    "improveTitle": "Pomóż ulepszać aplikację",
    "improveToggle": "Wysyłaj anonimowe statystyki",
    "improveHint": "Pomaga nam zrozumieć, co działa dobrze, a co poprawić. Bez danych osobowych.",
    "improvePrivacy": "Nie śledzimy lokalizacji ani zachowań — możesz to wyłączyć w każdej chwili.",
    "next": "Dalej",
    "back": "Wstecz",
    "skip": "Pomiń",
    "finish": "Zaczynamy",
    "situationPartner": "Mam partnera/partnerkę",
    "situationNote": "Zaznacz tylko to, co faktycznie masz. To nieobowiązkowe — możesz od razu przejść dalej.",
    "startTitle": "Witaj w Opiekunie Rodziny",
    "startNew": "Zaczynam",
    "startNewHint": "Pierwszy raz — poprowadzimy Cię krok po kroku.",
    "startRestore": "Mam już konto — przenoszę dane",
    "startRestoreHint": "Zaloguj się i odzyskaj swoje dane z chmury.",
    "startInvite": "Mam zaproszenie od bliskiej osoby",
    "startInviteHint": "Dostałeś kod gospodarstwa (HH-…)? Wpisz go tutaj.",
    "inviteCodeLabel": "Kod zaproszenia",
    "inviteCodeCta": "Dołącz do wspólnego budżetu",
    "contactTitle": "Zostańmy w kontakcie (opcjonalnie)",
    "contactEmailLabel": "Twój e-mail (opcjonalnie)",
    "contactEmailHint": "E-mail pozwala logować się bez hasła i odzyskać dane, gdyby coś się stało z telefonem.",
    "contactEmailInvalid": "Sprawdź adres e-mail albo zostaw pole puste.",
    "marketingConsent": "Chcę, żeby Polfinance przypominał mi o kończących się polisach i podsyłał okazje dla rodziny.",
    "policiesTitle": "Twoje polisy",
    "policiesSubtitle": "Zrób zdjęcie polisy — odczytamy ją, zapiszemy i przypilnujemy terminu. Możesz to też zrobić później.",
    "policiesEmptyQuestion": "A masz jakieś ubezpieczenia? Auto, mieszkanie, na życie… Jeśli tak — zrób zdjęcie polisy, a zapisze się sama. Nie masz albo nie wiesz? Po prostu przejdź dalej.",
    "policyCar": "Polisa auta (OC/AC)",
    "policyCarHint": "Zdjęcie polisy wystarczy — przypilnujemy końca OC.",
    "policyHome": "Ubezpieczenie mieszkania / domu",
    "policyHomeHint": "Zapiszemy ją i przypomnimy przed końcem ochrony.",
    "policyMortgage": "Polisa do kredytu",
    "policyMortgageHint": "Bank jej wymaga — dobrze mieć ją pod ręką.",
    "policyLife": "Polisa na życie",
    "policyLifeHint": "Zabezpieczenie bliskich — sprawdź, czy ją masz.",
    "policyBusiness": "OC firmy / działalności",
    "policyBusinessHint": "Zdjęcie polisy wystarczy do zapisania.",
    "policyGeneric": "Dowolna polisa",
    "policyGenericHint": "Zrób zdjęcie — resztę odczytamy za Ciebie.",
    "policyScanCta": "Skanuj",
    "policySaved": "Zapisana: {{summary}}",
    "policySavedUntil": "do {{date}}",
    "policyScanIncomplete": "Nie udało się odczytać wszystkich pól. Spróbuj wyraźniejszego zdjęcia albo dodaj polisę później w zakładce Polisy.",
    "policyReviewTitle": "Sprawdź odczytaną polisę",
    "policyReviewPremium": "Składka",
    "policyReviewNumber": "Numer polisy",
    "policyReviewOpenEnded": "bezterminowa",
    "policyReviewHint": "Coś się nie zgadza? Zapisz i popraw w zakładce Polisy — albo odrzuć i zeskanuj jeszcze raz.",
    "policyReviewDiscard": "Odrzuć",
    "policiesWatchNote": "Przypomnimy 30, 14, 7 i 1 dzień przed końcem ochrony.",
    "policiesPrivacyNote": "Zdjęcie służy tylko do odczytu — nie zapisujemy go na serwerze. Polisa zostaje na Twoim telefonie.",
    "incomeTitle": "Ile zarabiasz?",
    "incomeSubtitle": "Podaj miesięczną wypłatę — bez tego apka nie policzy prognozy miesiąca. Zajmie chwilę, a wszystko zostaje na telefonie.",
    "incomeNameLabel": "Nazwa źródła (opcjonalnie)",
    "incomeNamePlaceholder": "np. Wypłata — etat",
    "incomeAmountLabel": "Miesięczna wypłata (zł)",
    "incomeDayLabel": "Którego dnia miesiąca? (1–28, opcjonalnie)",
    "incomeHint": "Podasz dzień — zapytamy „czy wpłynęła wypłata?” i prognoza będzie żywa od pierwszego dnia. Wszystko zostaje na telefonie.",
    "incomeDefaultName": "Wypłata",
    "budgetFixedInfo": "Zapiszemy też jako opłaty stałe z przypomnieniem: {{list}}."
  },
  "rate": {
    "title": "Podoba Ci się Opiekun Rodziny?",
    "subtitle": "Twoja opinia bardzo nam pomaga",
    "lowTitle": "Co możemy poprawić?",
    "lowSubtitle": "Napisz nam, co nie zagrało — czytamy każdą wiadomość.",
    "commentPlaceholder": "Twoje uwagi...",
    "send": "Wyślij opinię",
    "later": "Może później",
    "thanksTitle": "Dziękujemy za ocenę!",
    "thanksBody": "Wiesz, że możesz też polecić nas znajomym i dostać 50 zł na paliwo?",
    "thanksCta": "Odbierz 50 zł na paliwo",
    "thanksSkip": "Nie, dziękuję"
  },
  "ideas": {
    "headerTitle": "Społeczność",
    "mine": "Twoje",
    "title": "Pomysły i błędy",
    "subtitle": "Zgłaszaj, głosuj — najczęściej wybierane robimy w pierwszej kolejności.",
    "filterAll": "Wszystko",
    "filterIdeas": "Pomysły",
    "filterBugs": "Błędy",
    "filterDone": "Zrealizowane",
    "sortMostVoted": "Najczęściej głosowane",
    "submit": "Zgłoś",
    "kindIdea": "Pomysł",
    "kindBug": "Błąd",
    "status": {
      "NEW": "Nowe",
      "IN_PROGRESS": "W trakcie",
      "DONE": "Zrobione"
    },
    "newTitle": "Zgłoś pomysł lub błąd",
    "fieldTitle": "Tytuł",
    "fieldTitlePlaceholder": "W skrócie, o co chodzi",
    "fieldDescription": "Opis",
    "fieldDescriptionPlaceholder": "Opisz szczegóły — co, gdzie, kiedy",
    "newNote": "Twoje zgłoszenie zobaczą inni użytkownicy i będą mogli na nie zagłosować.",
    "newSubmit": "Wyślij zgłoszenie",
    "detailTitle": "Szczegóły",
    "vote": "Zagłosuj ({{count}})",
    "voted": "Zagłosowano ({{count}})",
    "comments": "Komentarze",
    "noComments": "Brak komentarzy — bądź pierwszy.",
    "addComment": "Dodaj komentarz...",
    "you": "Ty",
    "notFound": "Nie znaleziono zgłoszenia."
  },
  "editGoal": {
    "title": "Edytuj cel",
    "dateLabel": "Data realizacji (opcjonalnie)",
    "iconLabel": "Wybierz ikonę",
    "save": "Zapisz zmiany",
    "delete": "Usuń cel",
    "deleteConfirm": "Na pewno usunąć? Kliknij ponownie",
    "iconHint": "Ikona jest tylko dla wyglądu — wybierz, która Ci się podoba."
  },
  "vault": {
    "title": "Skarbiec rodziny",
    "bannerTitle": "Wszystkie dane są zaszyfrowane",
    "bannerBody": "PESELE w systemowym sejfie telefonu (Keychain/Keystore), skany w prywatnym folderze aplikacji. Skarbiec NIE jest i nie będzie synchronizowany — istnieje tylko na tym telefonie, celowo.",
    "bannerWebTitle": "Dane zostają w tej przeglądarce",
    "bannerWebBody": "Pełne szyfrowanie (sejf systemowy) i skany dokumentów są dostępne w aplikacji na telefonie.",
    "members": "Członkowie rodziny",
    "add": "Dodaj",
    "addFirst": "Dodaj pierwszą osobę",
    "firstName": "Imię",
    "relSelf": "Ja",
    "relPartner": "Partner/ka",
    "relChild": "Dziecko",
    "relOther": "Inna osoba",
    "birthDate": "Data urodzenia (opcjonalnie)",
    "pesel": "PESEL (opcjonalnie)",
    "peselWebHint": "PESEL dodasz w aplikacji na telefonie — tam trafia do systemowego sejfu.",
    "saveMember": "Zapisz osobę",
    "born": "Urodzony(a): {{date}}",
    "showPesel": "Pokaż PESEL",
    "hidePesel": "Ukryj",
    "remove": "Usuń",
    "removeConfirm": "Na pewno? Kliknij ponownie",
    "kidsNudge": "Zaznaczyliście, że macie dzieci — dodaj datę urodzenia dziecka, przypomnimy o urodzinach.",
    "dates": "Ważne daty",
    "wedding": "Rocznica ślubu",
    "met": "Data poznania",
    "setDate": "Ustaw",
    "saveDate": "Zapisz datę",
    "remind": "Przypominaj o urodzinach i rocznicach",
    "documents": "Dokumenty",
    "docId": "Dowód osobisty",
    "docPassport": "Paszport",
    "docMarriage": "Akt małżeństwa",
    "newDoc": "Nowy dokument",
    "addScan": "DODAJ SKAN",
    "viewScan": "ZOBACZ SKAN",
    "deleteScan": "Usuń skan",
    "customDocLabel": "Nazwa dokumentu",
    "customDocPlaceholder": "np. Akt urodzenia",
    "footer": "Dane trzymane bezpiecznie na Twoim telefonie — bez synchronizacji, celowo",
    "footerWeb": "Dane zostają na tym urządzeniu"
  },
  "householdInvite": {
    "header": "Wspólne gospodarstwo",
    "title": "Utwórz wspólne gospodarstwo?",
    "subtitle": "Wspólnie zadbacie o budżet i cele rodziny.",
    "nameLabel": "Imię partnera/ki",
    "namePlaceholder": "np. Anna",
    "phoneLabel": "Numer telefonu (opcjonalnie)",
    "cta": "Utwórz i wyślij zaproszenie",
    "later": "Na razie sam/a",
    "note": "Zaproszenie wyślemy dopiero po Twoim kliknięciu — wybierzesz WhatsApp, SMS lub inną aplikację. Gdy druga osoba dołączy kodem gospodarstwa, wspólny budżet i cele zsynchronizują się na obu telefonach.",
    "messageNamed": "Hej! {{name}} zaprasza Cię do wspólnego prowadzenia domowego budżetu w aplikacji Opiekun Rodziny od Polfinance. Użyj tego kodu, żeby dołączyć: {{hhCode}} → {{url}}",
    "messageAnon": "Hej! Zapraszam Cię do wspólnego prowadzenia domowego budżetu w aplikacji Opiekun Rodziny od Polfinance. Użyj tego kodu, żeby dołączyć: {{hhCode}} → {{url}}",
    "messageNoCode": "Załóżmy wspólne gospodarstwo w aplikacji Opiekun Rodziny od Polfinance — budżet, cele i polisy w jednym miejscu. Pobierz: {{url}}",
    "sentInfo": "Użytkownik {{name}} został dodany do gospodarstwa. Zaproszenie gotowe do wysłania — jeśli okno udostępniania się nie otworzyło, wyślij link z ekranu „Poleć aplikację\".",
    "done": "Gotowe",
    "codesTitle": "Kody do udostępnienia",
    "hhCodeLabel": "Kod gospodarstwa (budżet i cele)",
    "referralCodeLabel": "Twój kod polecenia (talon 50 zł na paliwo)",
    "codeCopied": "Skopiowano"
  },
  "householdSettings": {
    "title": "Ustawienia gospodarstwa",
    "nameLabel": "Nazwa gospodarstwa",
    "budgetLabel": "Miesięczny budżet (zł)",
    "save": "Zapisz",
    "saved": "Zapisano",
    "situation": "Wasza sytuacja",
    "members": "Domownicy",
    "remove": "Usuń",
    "removeConfirm": "Na pewno?"
  },
  "income": {
    "title": "Zarobki",
    "prevMonth": "Poprzedni miesiąc",
    "nextMonth": "Następny miesiąc",
    "totalThisMonth": "Dochody gospodarstwa w tym miesiącu",
    "overdueTitle": "Do uzupełnienia",
    "overdueRow": "Czy wpłynęła wypłata: {{name}}? (zwykle {{day}}. dnia)",
    "you": "Ty",
    "noSources": "Brak źródeł dochodu — dodaj pierwsze poniżej.",
    "addAmount": "Dodaj kwotę",
    "amountLabel": "Kwota — {{month}} (zł)",
    "noteLabel": "Notatka (opcjonalnie)",
    "notePlaceholder": "np. premia, nadgodziny, wyrównanie",
    "save": "Zapisz",
    "removeSource": "Usuń to źródło dochodu",
    "removeConfirm": "Na pewno? Kliknij ponownie",
    "addSource": "Dodaj źródło dochodu",
    "srcNameLabel": "Nazwa źródła",
    "srcNamePlaceholder": "np. praca na etacie, 800+, firma",
    "srcDayLabel": "Którego dnia miesiąca zwykle wpływa? (opcjonalnie)",
    "srcDayHint": "Tego dnia zapytamy: „czy wpłynęła wypłata i ile?\"",
    "srcSave": "Zapisz źródło",
    "kindEtat": "Etat",
    "kind800": "800+",
    "kindBusiness": "Działalność",
    "kindCommission": "Prowizja",
    "kindOther": "Inne",
    "dayOfMonth": "dnia miesiąca",
    "daySuggestion": "Wypłatę z {{name}} potwierdzasz zwykle ok. {{day}}. dnia miesiąca — przestawić przypomnienie?",
    "daySuggestionAccept": "Zmień na {{day}}.",
    "daySuggestionKeep": "Zostaw",
    "chartsTitle": "Wykresy",
    "tabSummary": "Podsumowanie",
    "tabSources": "Źródła",
    "tabShare": "Udział",
    "allSources": "Wszystkie",
    "shareTitle": "Kto ile przynosi do gospodarstwa",
    "sharePeriod": "Ostatnie 12 miesięcy · dzieci nie są liczone",
    "shareNeedsTwo": "Wykres udziału pojawi się, gdy co najmniej dwie dorosłe osoby będą miały wpisane dochody.",
    "import": "Import z pliku",
    "importError": "Nie udało się wczytać pliku. Sprawdź, czy to poprawny JSON importu.",
    "privacyNote": "Zapisujemy tylko na Twoim telefonie. Nikt — nawet my — nie ma do tego dostępu."
  },
  "fixedCosts": {
    "title": "Opłaty stałe",
    "totalLabel": "Razem opłaty stałe",
    "perMonth": "mies.",
    "trendLabel": "Jak zmieniała się suma opłat",
    "cushionTitle": "Poduszka bezpieczeństwa",
    "cushionBody": "Wasze oszczędności z celów pokrywają ok. {{count}} mies. opłat stałych.",
    "empty": "Brak opłat — dodaj czynsz, prąd, internet…",
    "daySuggestion": "Opłatę {{name}} potwierdzasz zwykle ok. {{day}}. dnia miesiąca — przestawić przypomnienie?",
    "daySuggestionAccept": "Zmień na {{day}}.",
    "daySuggestionKeep": "Zostaw",
    "markPaid": "Oznacz jako zapłacone",
    "unmarkPaid": "Cofnij zapłacone",
    "dueDay": "płatne {{day}}. dnia miesiąca",
    "dueStart": "płatne na początku miesiąca",
    "historyLabel": "Historia kwoty",
    "historyNow": "teraz",
    "newAmountLabel": "Nowa kwota (zł)",
    "saveAmount": "Zapisz kwotę",
    "remove": "Usuń opłatę",
    "removeConfirm": "Na pewno? Kliknij ponownie",
    "nameLabel": "Nazwa opłaty",
    "namePlaceholder": "np. Czynsz, Prąd, Netflix",
    "amountLabel": "Kwota (zł)",
    "dayLabel": "Dzień płatności (opcjonalnie)",
    "dayHint": "Bez dnia = pokażemy na początku miesiąca. W dniu płatności zapytamy „zapłacone?\".",
    "addToBudget": "Po odhaczeniu dopisuj wydatek do budżetu",
    "add": "Dodaj opłatę",
    "footerInfo": "Odhaczenie „zapłacone\" dopisuje kwotę do budżetu (kategoria Rachunki). Zmiana kwoty zachowuje starą w historii — zobaczysz, jak rosły opłaty.",
    "budgetRow": "Razem {{total}} / mies. · odhaczaj płatności",
    "budgetRowEmpty": "Dodaj czynsz, prąd, subskrypcje — przypomnimy o płatnościach",
    "tapToAdd": "Dotknij, aby dodać opłatę"
  },
  "school": {
    "subtitle": "Krótkie lekcje o pieniądzach rodziny — 5 minut dziennie.",
    "progress": "{{pct}}% ukończono",
    "day": "Dzień {{day}}",
    "taskTitle": "Zadanie na dziś",
    "sources": "Źródła",
    "disclaimer": "Treści mają charakter edukacyjny — to nie jest doradztwo finansowe, inwestycyjne ani podatkowe.",
    "markDone": "Oznacz jako przeczytane",
    "doneInfo": "Lekcja przeczytana — kolejny dzień odblokowany."
  },
  "legal": {
    "title": "Regulamin i zasady",
    "intro": "Najważniejsze zasady korzystania z Opiekuna Rodziny — po ludzku. Pełny regulamin i politykę prywatności znajdziesz niżej, w aplikacji.",
    "freeTitle": "Aplikacja jest bezpłatna",
    "freeBody": "Wszystkie funkcje są darmowe. Konto jest opcjonalne — logujesz się numerem telefonu i kodem SMS, bez hasła i bez e-maila.",
    "localTitle": "Twoje dane domyślnie zostają na telefonie",
    "localBody": "Bez konta nic nie wysyłamy na serwery. Budżet, cele, zarobki i opłaty żyją na Twoim urządzeniu.",
    "cloudTitle": "Chmura tylko na Twoje życzenie",
    "cloudBody": "Po zalogowaniu możesz włączyć kopię w chmurze (serwery w UE). Kopia to nieprzezroczysty plik — serwer jej nie analizuje. Usuwasz ją jednym przyciskiem.",
    "vaultTitle": "Skarbiec rodziny — tylko na tym telefonie",
    "vaultBody": "PESELE, ważne daty i skany dokumentów tożsamości NIGDY nie trafiają na serwer. Skarbiec celowo nie jest i nie będzie synchronizowany — możesz z niego korzystać, ale kopia zapasowa tych danych jest po Twojej stronie.",
    "scanTitle": "Skan polisy — bez przechowywania pliku",
    "scanBody": "Zdjęcie lub PDF polisy wysyłamy wyłącznie do jednorazowego odczytu danych. Plik nie jest zapisywany na serwerze. Obowiązuje dzienny limit skanów.",
    "referralTitle": "Program poleceń — talon 50 zł na paliwo",
    "referralBody": "Gdy nowy klient (bez wcześniejszych polis w Polfinance) założy konto z Twoim kodem i kupi polisę w Polfinance, oboje dostajecie talon 50 zł na paliwo. Wypłatę weryfikuje biuro. Nadużycia (fikcyjne konta, samopolecanie) wykluczają talon. Polfinance może zmienić lub zakończyć program. Pełny, zawsze aktualny regulamin: polfinance.pl/polecaj.",
    "eduTitle": "Edukacja, nie doradztwo",
    "eduBody": "Treści aplikacji — w tym Szkoła finansów i prognozy — mają charakter edukacyjny i poglądowy. To nie jest doradztwo finansowe, inwestycyjne ani prawne.",
    "complaintsTitle": "Reklamacje i kontakt",
    "complaintsBody": "Pisz na kontakt@polfinance.pl — odpowiadamy do 14 dni. Aplikacja jest dla osób od 16 lat. Prawo polskie.",
    "footer": "Wersja robocza zasad z 2026-07-12 — pełne dokumenty po przeglądzie prawnika."
  },
  "forecast": {
    "title": "Twój miesiąc",
    "learnCaption": "Aplikacja uczy się Twoich wpisów i przewiduje, ile zostanie Ci w tym miesiącu.",
    "leftPositive": "Zostanie ok. {{amount}}",
    "leftNegative": "Zabraknie ok. {{amount}}",
    "toMonthEnd": "do końca miesiąca",
    "runsOut": "Przy obecnym tempie wydatków budżet skończy się ok. {{day}}. dnia miesiąca.",
    "willSave": "Przy tym tempie odłożysz ok. {{amount}} — dopisz do celu, gdy miesiąc się domknie.",
    "subtitle": "Analiza bieżących przychodów i planowanych wydatków",
    "centerLabelPositive": "Zostanie ok.",
    "centerLabelNegative": "Zabraknie ok.",
    "centerPill": "Na koniec miesiąca",
    "income": "Przychody",
    "outflow": "Wydatki",
    "markerIncome": "Wpływ",
    "markerCost": "Opłata",
    "markerDay": "{{day}}. dnia miesiąca",
    "markerHint": "Dotknij zielonej lub pomarańczowej ikonki, aby zobaczyć co to.",
    "tapCenterHint": "Dotknij środka, aby zmienić widok",
    "modeNextIncome": "Następny wpływ za",
    "modeNextCost": "Następna opłata za",
    "tapAmountHint": "Dotknij kwoty, aby zmienić widok",
    "incomePlan": "Prognoza wpływów",
    "outflowPlan": "Prognoza wydatków",
    "planNote": "To prognoza na cały miesiąc (tempo wydatków + opłaty stałe). Wydane do dziś: {{spent}}."
  },
  "forecastHistory": {
    "chartTitle": "Wydatki skumulowane",
    "stateAt": "Stan na {{day}} {{month}}",
    "forecastOfDay": "Prognoza z tego dnia:",
    "listEmpty": "Brak wydatków tego dnia.",
    "textBody": "{{date}}: wydatki tego dnia {{daySpent}}, od początku miesiąca {{monthSpent}}.",
    "textLeftPositive": "Prognoza z tego dnia: zostanie ok. {{amount}}.",
    "textLeftNegative": "Prognoza z tego dnia: zabraknie ok. {{amount}}.",
    "prevMonth": "Poprzedni miesiąc",
    "nextMonth": "Następny miesiąc",
    "view": {
      "ring": "Wykres",
      "list": "Lista",
      "text": "Tekst"
    },
    "month": {
      "1": "Styczeń", "2": "Luty", "3": "Marzec", "4": "Kwiecień", "5": "Maj", "6": "Czerwiec",
      "7": "Lipiec", "8": "Sierpień", "9": "Wrzesień", "10": "Październik", "11": "Listopad", "12": "Grudzień"
    },
    "monthGen": {
      "1": "stycznia", "2": "lutego", "3": "marca", "4": "kwietnia", "5": "maja", "6": "czerwca",
      "7": "lipca", "8": "sierpnia", "9": "września", "10": "października", "11": "listopada", "12": "grudnia"
    },
    "weekday": {
      "1": "Pn", "2": "Wt", "3": "Śr", "4": "Cz", "5": "Pt", "6": "So", "7": "Nd"
    }
  },
  "adaptive": {
    "title": "Coś się zmieniło w planie",
    "incomeRow": "Wypłata z {{name}} miała wpłynąć {{day}}. — wpłynęła?",
    "costRow": "{{name}} {{amount}} — opłata miała być {{day}}. Zapłacona?",
    "arrived": "Wpłynęła",
    "paid": "Zapłacone",
    "notYet": "Jeszcze nie",
    "didNotHappen": "Nie było",
    "amountLabel": "Kwota (zł)",
    "updatedTitle": "Zaktualizowałem plan",
    "updatedNoData": "Prognoza przeliczona."
  },
  "strength": {
    "title": "Siła prognozy",
    "headlineHigh": "Prognozy w pełnej mocy!",
    "headlineLow": "Jeszcze chwila!",
    "subtitle": "Im więcej wpisów, tym trafniej przewidzimy Twój miesiąc — dochody, opłaty i to, ile zostanie.",
    "stage1": "Uczenie się",
    "stage1Sub": "1. miesiąc",
    "stage2": "Kalibrowanie",
    "stage2Sub": "2–3 mies.",
    "stage3": "Dopracowywanie",
    "stage3Sub": "3+ mies.",
    "howTitle": "Jak działa prognozowanie",
    "howBody1": "Liczymy wyłącznie z Twoich wpisów: typowe kwoty źródeł dochodu, dni wypłat, opłaty stałe i tempo wydatków w tym miesiącu. Nic nie zgadujemy z powietrza i nic nie wysyłamy na serwer.",
    "howBody2": "Rejestruj wydatki i uzupełniaj zarobki, a prognozy będą coraz trafniejsze — z każdym wpisem.",
    "boostTitle": "Co podnosi wynik",
    "boost1": "Uzupełnione zarobki za kolejne miesiące (najmocniejszy składnik)",
    "boost2": "Dodane opłaty stałe (czynsz, prąd, subskrypcje)",
    "boost3": "Regularne wpisywanie wydatków w tym miesiącu",
    "boost4": "Ustawione dni wypłat przy źródłach dochodu"
  },
  "tutorial": {
    "addTitle": "Wszystko dodajesz przyciskiem +",
    "addBody": "Wydatek, wpłatę na cel, dochód, opłatę stałą albo skan polisy — jeden przycisk „+” pośrodku dolnego paska.",
    "pullTitle": "Pociągnij w dół po podsumowanie",
    "pullBody": "Na Starcie chwyć górę ekranu i przeciągnij palcem w dół — nasunie się podsumowanie miesiąca, kwartału i roku.",
    "settingsTitle": "Górne kółko to Twoje ustawienia",
    "settingsBody": "Dotknij kółka w lewym górnym rogu, aby wejść w konto i ustawienia: logowanie, prywatność i synchronizacja.",
    "strengthTitle": "Obok jest Siła prognozy",
    "strengthBody": "Aplikacja uczy się Twoich wydatków i wypłat, liczy je i przewiduje, ile zostanie Ci w tym miesiącu. Im więcej wpiszesz, tym celniej — po 1–3 miesiącach prognoza jest naprawdę trafna.",
    "next": "Dalej",
    "done": "Rozumiem",
    "skip": "Pomiń przewodnik",
    "habitTitle": "Tak korzystasz na co dzień",
    "habitBody": "Jesteś w sklepie? Dodaj wydatek przyciskiem „+” (np. jedzenie). Na bieżąco widzisz, ile wydajesz, i masz kontrolę nad budżetem oraz zarobkami.",
    "referTitle": "Prezent: 50 zł za polecenie",
    "referBody": "Dotknij ikony prezentu, poleć aplikację znajomym i odbierz 50 zł na paliwo za skuteczne polecenie."
  },
  "fab": {
    "title": "Nowa akcja",
    "expense": "Wydatek",
    "goal": "Wpłata na cel",
    "income": "Dochód",
    "fixedCost": "Opłata stała",
    "scan": "Dodaj zdjęcie polisy",
    "reminder": "Przypomnienie"
  },
  "budgetCalc": {
    "title": "Policzmy Twój budżet",
    "subtitle": "Wpisz miesięczne kwoty — zsumujemy je na propozycję budżetu. Puste pola pomiń.",
    "rent": "Czynsz / mieszkanie",
    "food": "Jedzenie i zakupy",
    "bills": "Rachunki (prąd, gaz, internet)",
    "transport": "Transport / paliwo",
    "loans": "Raty i kredyty",
    "subs": "Subskrypcje (Netflix, Spotify…)",
    "invest": "Oszczędności / inwestycje (XTB, IKE)",
    "other": "Inne",
    "sum": "Razem miesięcznie",
    "apply": "Użyj kwoty {{amount}}",
    "dayLabel": "Kiedy płacisz? Dzień miesiąca (opcjonalnie)",
    "dayHint": "Podasz dzień (1–28) — zapiszemy to jako opłatę stałą i przypomnimy o płatności."
  }
}